// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".payment-link[data-v-4fce276a]{display:flex;align-items:center;grid-gap:10px;gap:10px;justify-content:center}.payment-link__copy-icon[data-v-4fce276a]{cursor:pointer;opacity:.5;transition:.3s}.payment-link__copy-icon[data-v-4fce276a]:hover{opacity:1}.alert[data-v-4fce276a]{color:#c37f00;margin-right:5px}", ""]);
// Exports
module.exports = exports;
